export default __webpack_public_path__ + "b91e36e3ee0386ffbeabdd103338cc18.svg";